import React from "react";
import { education } from "../../portfolio.js";
import Header from "../Header/Header";
function Education() {
  return (
    <div>
      <Header title="Education" />
      <div className="timeline">
        <div className="container">
          {education.edudata.map((val, idx) => {
            return (
              <div className="timeline-item">
                <div className="timeline-img"></div>
                <div className={val.side}>
                  <div className="row edu-border">
                    <div>
                      <h2 className="text-center f_color">{val.title}</h2>
                      <p className="text-center f_color">{val.date}</p>
                    </div>
                    <div className="col-md-6">
                      <ul>
                        {val.content.map((item, i) => {
                          return <li className="d_color">{item}</li>;
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Education;
